import React from 'react';
import { Avatar as AvatarComponent } from '@material-ui/core';
import PropTypes from 'prop-types';
import PersonIcon from '@material-ui/icons/Person';

const Avatar = ({ src, children, ...props }) => {
  return src ? (
    <AvatarComponent aria-label="avatar" src={src} {...props} />
  ) : (
    <AvatarComponent aria-label="avatar" {...props}>
      {children || <PersonIcon />}
    </AvatarComponent>
  );
};

Avatar.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  /** Path to source image */
  src: PropTypes.string,
  /** You can wrap some html for it to be a content for avatar */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

Avatar.defaultProps = {
  classes: {},
};

export default Avatar;
